module.exports = __webpack_public_path__ + "img/01-illu-kafu0510.bc503363.png";